import React, { Component, createRef } from "react";
import "component/game/GameItem/styles.scss";
import { isEqual } from "lodash";

class GameItem extends Component {
  constructor(props) {
    super(props);
    this.loadGame = this._loadGame.bind(this);
    this.gameElement = createRef();
    this.state = {
      game: null,
      gameUrl: null,
      isLoading: true,
    };
  }

  _loadGame(game) {
    let newGame = game;
    let isDeviceTypeEven = newGame.get("deviceType")
      ? newGame.get("deviceType") % 2 === 0
      : true;

    if (newGame.get("playType") === "game.details") {
      newGame = newGame.set("playType", "launch.real");
    }

    let { width, height } = this.gameElement.current.getBoundingClientRect();

    let params = new URLSearchParams();
    params.deviceType = width > height ? "DESKTOP" : "MOBILE";

    if (!this.state.initDeviceType) {
      this.setState({
        initDeviceType: params.deviceType,
      });
    } else if (
      this.state.initDeviceType === "MOBILE" &&
      newGame.get("deviceType")
    ) {
      newGame = newGame.set(
        "deviceType",
        isDeviceTypeEven ? "MOBILE" : "DESKTOP",
      );
      params.deviceType = isDeviceTypeEven ? "MOBILE" : "DESKTOP";
    } else if (
      this.state.initDeviceType === "DESKTOP" &&
      newGame.get("deviceType")
    ) {
      newGame = newGame.set(
        "deviceType",
        isDeviceTypeEven ? "DESKTOP" : "MOBILE",
      );
      params.deviceType = isDeviceTypeEven ? "DESKTOP" : "MOBILE";
    }

    this.props
      .fetchGame(newGame)
      .then((resp) => {
        this.setState({
          game: resp,
        });
        return resp;
      })
      .then((resp) => {
        let links = resp.payload.get("links");
        let playRoute = links.find((link) => {
          return link.get("rel") === newGame.get("playType");
        });

        if (playRoute) {
          return this.props.fetchGameUrl(playRoute, params).then((resp) => {
            return resp.payload.data.url;
          });
        } else {
          return;
        }
      })
      .then((resp) => {
        this.setState({
          gameUrl: resp,
          isLoading: false,
        });
      })
      .catch((err) => {
        throw err;
      });
    this.props.onGameLaunch(this.props.params);
  }

  componentDidMount() {
    if (this.props.game) {
      this.loadGame(this.props.game);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.game, this.props.game) && nextProps.game) {
      this.setState({
        game: null,
        gameUrl: null,
        isLoading: true,
      });
      this.loadGame(nextProps.game);
    }
  }
  render() {
    return (
      <div className="game-item" ref={this.gameElement} data-testid="game-container">
        {this.state.game && (
          <iframe
            title="Game"
            className="gameFrame"
            src={this.state.gameUrl}
            frameBorder="0"
            height="1200"
            scrolling="yes"
          />
        )}
      </div>
    );
  }
}

export default GameItem;
